module.exports = __webpack_public_path__ + "static/media/framelength.6e71ec0d.svg";